export default function Loader() {
  return <div className="loader align-self-center"></div>;
}
